export default [
  {
    path: '/admin/message-config/message-rule/index',
    name: 'M020066',
    component: () =>
      import('@/views/admin/message-config/message-rule/RuleIndex.vue'),
    meta: { layout: 'admin' },
  },
];
